export default __webpack_public_path__ + "static/media/career-04.c12704dc.jpg";